module.exports = __webpack_public_path__ + "static/media/template6-carousel.e271888d.png";